import { DetailPageLoadingCenter } from 'components/DetailPageLoadingCenter';
import { GlobalUXState } from 'components/GlobalUXState';
import { DetailFieldsSkeleton } from './DetailFieldsSkeleton';
import { NotificationDetailCardSkeleton } from './NotificationDetailCardSkeleton';
import { TabBarSkeleton } from './TabBarSkeleton';
import { SectionPanelSkeleton } from './SectionPanelSkeleton';

export const DetailPageState = ({
  isLoading,
  hasError,
  onRetry,
  loadingLabel = 'Loading...',
  skeletonVariant = 'fields',
  fieldCount = 7,
  tabCount = 7,
  sectionCount = 0,
  compact = false,
  children,
}) => {
  if (isLoading) {
    if (skeletonVariant === 'notification-card') {
      return <NotificationDetailCardSkeleton />;
    }

    if (skeletonVariant === 'tabbed') {
      return (
        <>
          <DetailFieldsSkeleton fieldCount={fieldCount} />
          <TabBarSkeleton tabCount={tabCount} />
          <SectionPanelSkeleton />
        </>
      );
    }

    if (skeletonVariant === 'fields') {
      return <DetailFieldsSkeleton fieldCount={fieldCount} />;
    }

    return (
      <DetailPageLoadingCenter
        label={loadingLabel}
        compact={compact}
        showSlowLoadingHint={!compact}
      />
    );
  }

  if (hasError) {
    return <GlobalUXState variant="apiError" actionLabel="Try again" onAction={onRetry} />;
  }

  return children;
};
